<div class="container quick-links-page">

   <div class="mt-3">

      <h2 class="d-flex justify-content-center">
         <span class="fw-bold text-uppercase text-site-secondary">{{quickLinksTitle}}</span>
      </h2>

      <hr class="mb-4" />

      <p class="text-center intro mx-auto mb-4">
         Jump straight to the tools and sites you use most. Links open in a new tab.
      </p>

      <div class="row g-3 g-md-4">

         @for (link of links; track link.uri) {
            <div class="col-12 col-sm-6 col-lg-4">
               <a class="quick-link-card d-flex flex-column h-100 p-4 rounded-3 bg-white shadow-sm"
                  href="{{link.uri}}"
                  target="_blank"
                  rel="noopener"
                  [attr.aria-label]="link.title + ' (opens in a new tab)'"
                  title="{{link.title}}">

                  <div class="d-flex align-items-start justify-content-between mb-3">
                     <span class="icon-wrap d-inline-flex align-items-center justify-content-center rounded-circle bg-site-tertiary">
                        <img class="icon" src="/assets/images/icons/{{link.icon}}" alt="">
                     </span>

                     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-box-arrow-up-right external-hint mt-1" viewBox="0 0 16 16" aria-hidden="true">
                        <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                        <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
                     </svg>
                  </div>

                  <span class="card-title fw-bold fs-5 lh-sm mb-1">{{link.title}}</span>
                  <span class="card-description small flex-grow-1">{{link.description}}</span>

                  <span class="card-cta small fw-bold mt-3 d-inline-flex align-items-center gap-1">
                     Open
                     <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16" aria-hidden="true">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z" />
                     </svg>
                  </span>

               </a>
            </div>
         }

      </div>

      <div class="d-flex justify-content-center mt-5 mb-4">
         <button type="button" class="btn btn-outline-secondary sign-out-btn d-inline-flex align-items-center gap-2 px-4" (click)="logout()">
            <img class="sign-out-icon" src="/assets/images/icons/sign-out.png" alt="">
            Sign Out
         </button>
      </div>

   </div>

</div>
